<div class="location-dots-v">
    <ul class="multistep-progress-2-v">
        <li *ngFor="let item of data; let i = index;" [class]="getClassV2(item)">
            <location-info [data]="item.loc" [story]="story" [useDefaultPhoto]="useDefaultPhotos" [check]="true"
                [icon]="true" tappable (click)="clicked(i)"></location-info>
        </li>
    </ul>
</div>